import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ServicePageLayout from '../../components/Layout/ServicePageLayout';
import { FaSwift, FaWifi } from 'react-icons/fa';
import { SiKotlin, SiFirebase } from 'react-icons/si';
import { MdEmail, MdWork, MdLanguage, MdPhone, MdPerson, MdMessage } from 'react-icons/md';
import { submitToGoogleSheet } from '../../utils/helpers';
import classes from './ServicePage.module.scss';
import contactClasses from '../../components/Contact/Contact.module.scss';
import { TbBrandReactNative } from 'react-icons/tb';
import { FaFlutter } from 'react-icons/fa6';

import zazidatingPortfolio from '../../assets/zazidating_portfolio.png';
import palmistryPortfolio from '../../assets/palmistry_portfolio.png';
import artistNextDoorPortfolio from '../../assets/artist_next_door_web_portfolio.png';

import reactNativeMobile from '../../assets/react_native_mobile.png';
import flutterMobile from '../../assets/flutter_mobile.png';
import iosDevMobile from '../../assets/ios_dev_mobile.png';
import androidDevMobile from '../../assets/android_dev_mobile.png';
import uiUxMobile from '../../assets/ui_ux_mobile.png';
import maintenanceSupportMobile from '../../assets/maintenance_and_support_mobile.png';
import mobileAppLanding from '../../assets/mobile_app_landingpage.png';
import FAQ from '../../components/FAQ/FAQ';

const MobileAppDevelopment = () => {
  const { projects } = useSelector((state) => state.portfolio);
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitToGoogleSheet(formData);
      if (typeof window.gtag_report_conversion === 'function') {
        window.gtag_report_conversion();
      }
      alert('Thank you! We will get back to you soon.');
      setFormData({ name: '', email: '', phoneNumber: '', message: '' });
    } catch (error) {
      console.error('Form submission error:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Mobile projects with portfolio data
  const mobileProjects = [
    {
      id: 1,
      title: 'ZAZI DATING',
      subtitle: 'Mobile App Development',
      description: 'Modern dating application with advanced matching algorithms, real-time messaging, and intuitive user interface designed to create meaningful connections.',
      image: zazidatingPortfolio,
      category: 'Mobile',
      link: '/services/mobile-app-development',
      bgGradient: 'linear-gradient(135deg, rgb(229 134 144) 0%, rgb(219 103 130) 100%)'
    },
    {
      id: 2,
      title: 'PALMISTRY APP',
      subtitle: 'AI/ML Mobile Development',
      description: 'Advanced palmistry reading app using AI/ML for accurate predictions and personalized insights with cutting-edge computer vision technology.',
      image: palmistryPortfolio,
      category: 'AI/ML',
      link: '/services/web-development',
      bgGradient: 'linear-gradient(135deg, rgb(96 27 48) 0%, rgb(98 47 54) 100%)'
    },
    {
      id: 3,
      title: 'ARTIST NEXT DOOR',
      subtitle: 'Mobile & Web App Development',
      description: 'Mobile companion app and webapp for artists to manage bookings, showcase work, and communicate with clients on the go.',
      image: artistNextDoorPortfolio,
      category: 'Mobile',
      link: '/services/mobile-app-development',
      bgGradient: 'linear-gradient(135deg, rgb(133 89 200) 0%, rgb(52 29 89) 100%)'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % mobileProjects.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + mobileProjects.length) % mobileProjects.length);
  };

  const technologies = [
    { name: 'React Native', icon: <TbBrandReactNative />, description: 'Cross-platform mobile apps' },
    { name: 'Flutter', icon: <FaFlutter />, description: 'High-performance mobile apps' },
    { name: 'Swift', icon: <FaSwift />, description: 'Native iOS development' },
    { name: 'Kotlin', icon: <SiKotlin />, description: 'Modern Android development' },
    { name: 'Firebase', icon: <SiFirebase />, description: 'Auth, realtime DB & cloud messaging' },
  ];

  const features = [
    {
      title: 'React Native Development',
      description: 'Cross-platform mobile apps with native performance and single codebase efficiency.',
      image: reactNativeMobile
    },
    {
      title: 'Flutter Development',
      description: 'High-performance mobile applications with beautiful, customizable UI components.',
      image: flutterMobile
    },
    {
      title: 'iOS Development',
      description: 'Native iOS applications using Swift and latest Apple development frameworks.',
      image: iosDevMobile
    },
    {
      title: 'Android Development',
      description: 'Modern Android apps with Kotlin and cutting-edge Google technologies.',
      image: androidDevMobile
    },
    {
      title: 'UI/UX Design',
      description: 'Intuitive mobile interfaces following platform-specific design guidelines.',
      image: uiUxMobile
    },
    {
      title: 'Maintenance & Support',
      description: 'Ongoing app maintenance, updates, and technical support services.',
      image: maintenanceSupportMobile
    },

  ];

  const faqs = [
    {
      question: 'How long does it take to build a mobile app?',
      answer: 'A typical mobile app takes 3-6 months from concept to launch, depending on complexity. Simple apps with core features can be delivered in 8-12 weeks, while feature-rich apps with custom backends, integrations, and advanced UI may take 6-9 months.'
    },
    {
      question: 'Should I build a native app or a cross-platform app?',
      answer: 'Cross-platform frameworks like React Native and Flutter let you ship on both iOS and Android from a single codebase, saving 30-40% in development costs. We recommend native (Swift/Kotlin) only when you need deep platform-specific features like AR, advanced animations, or hardware-level access.'
    },
    {
      question: 'How much does mobile app development cost?',
      answer: 'Cost depends on features, design complexity, and platform choice. A basic MVP typically starts from a few thousand dollars, while a full-featured app with backend, third-party integrations, and polished UI can range higher. We provide detailed estimates after understanding your requirements.'
    },
    {
      question: 'Do you provide post-launch support and maintenance?',
      answer: 'Yes. We offer ongoing maintenance plans that include bug fixes, OS compatibility updates, performance monitoring, feature enhancements, and app store compliance. We ensure your app stays up-to-date and runs smoothly after launch.'
    },
    {
      question: 'Can you integrate Firebase into my existing app?',
      answer: 'Absolutely. We integrate Firebase services including Authentication, Firestore, Realtime Database, Cloud Messaging (push notifications), Crashlytics, Analytics, and Remote Config into both new and existing mobile applications.'
    },
    {
      question: 'Will my app work offline?',
      answer: 'Yes, we build offline-first mobile apps using local storage, SQLite, and background sync strategies. Users can continue using core features without an internet connection, and data automatically syncs when connectivity is restored.'
    },
  ];

  const process = [
    { step: '01', title: 'Discovery & Planning', description: 'Understanding requirements and creating detailed project roadmap' },
    { step: '02', title: 'UI/UX Design', description: 'Creating intuitive designs following platform guidelines' },
    { step: '03', title: 'Development', description: 'Building robust, scalable mobile applications' },
    { step: '04', title: 'Testing & QA', description: 'Comprehensive testing across devices and platforms' },
    { step: '05', title: 'Deployment', description: 'App store submission and launch support' },
    { step: '06', title: 'Maintenance', description: 'Ongoing support, updates, and feature enhancements' },
  ];

  return (
    <ServicePageLayout>
      <div className={classes.servicePageContainer}>
        {/* Hero Section */}
        <section className={classes.hero}>
          <div className={classes.container}>
            <div className={classes.heroContent}>
              <div className={classes.heroHighlight}>
                <div className={classes.heroText}>

                  <h1 className={classes.heroTitle}>
                    Mobile App <span className={classes.gradient}>Development</span>
                  </h1>
                  <p className={classes.heroSubtitle}>
                    Create powerful, native-quality mobile applications that engage users and drive business growth.
                    From concept to app store, we deliver exceptional mobile experiences.
                  </p>
                  <div className={classes.heroCTA}>
                    <button 
                      className={classes.exploreButton}
                      onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}
                    >
                      Explore Services
                    </button>
                    <button 
                      className={classes.quoteButton}
                      onClick={() => document.getElementById('contact-form').scrollIntoView({ behavior: 'smooth' })}
                    >
                      Get A Quote
                    </button>
                  </div>
                  <div className={classes.heroStats}>
                    <div className={classes.stat}>
                      <span className={classes.statNumber}>{20}+</span>
                      <span className={classes.statLabel}>Mobile Apps Built</span>
                    </div>
                    <div className={classes.stat}>
                      <span className={classes.statNumber}>100k+</span>
                      <span className={classes.statLabel}>App Downloads</span>
                    </div>
                    <div className={classes.stat}>
                      <span className={classes.statNumber}>99%</span>
                      <span className={classes.statLabel}>Client Satisfaction</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.heroVisual}>
                <div className={classes.phoneContainer}>
                  <div className={classes.phoneGlow}></div>
                  <img
                    src={mobileAppLanding}
                    alt="Mobile App Landing"
                    className={classes.phoneImage}
                  />

                </div>
              </div>
            </div>
          </div>
        </section>



        {/* Features Section */}
        <section id="features" className={classes.features}>
          <div className={classes.container}>
            <div className={classes.sectionHeader}>
              <h2 className={classes.sectionTitle}>
                Why Choose Our <span className={classes.gradient}>Mobile Development</span>
              </h2>
            </div>
            <div className={classes.featuresGrid}>
              {features.map((feature, index) => (
                <div key={index} className={classes.featureCard}>
                  <div className={classes.featureImageContainer}>
                    <img
                      src={feature.image}
                      alt={feature.title}
                      className={classes.featureImage}
                    />
                  </div>
                  <h3 className={classes.featureTitle}>{feature.title}</h3>
                  <p className={classes.featureDescription}>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Technologies Section */}
        <section className={classes.technologies}>
          <div className={classes.container}>
            <div className={classes.sectionHeader}>
              <h2 className={classes.sectionTitle}>
                Technologies We <span className={classes.gradient}>Master</span>
              </h2>
              <p className={classes.sectionSubtitle}>
                Using cutting-edge frameworks and tools to build world-class mobile applications
              </p>
            </div>
            <div className={classes.techGrid}>
              {technologies.map((tech, index) => (
                <div key={index} className={classes.techCard}>
                  <div className={classes.techIcon}>{tech.icon}</div>
                  <h3 className={classes.techName}>{tech.name}</h3>
                  <p className={classes.techDescription}>{tech.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Projects Section */}
        <section className={classes.portfolioSection}>
          <div className={classes.portfolioContainer}>
            <div className={classes.portfolioHeader}>
              <h2 className={classes.portfolioTitle}>
                Our Mobile <span className={classes.gradient}>Projects</span>
              </h2>
            </div>

            <div className={classes.carousel}>
              <div className={classes.slideContainer}>
                <div
                  className={classes.slides}
                  style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                  {mobileProjects.map((project, index) => (
                    <div
                      key={project.id}
                      className={classes.slide}
                      style={{ background: project.bgGradient }}
                    >
                      <div className={classes.slideContent}>
                        <div className={classes.slideTop}>
                          <div className={classes.imageContainer}>
                            <img src={project.image} alt={project.title} />
                          </div>
                        </div>

                        <div className={classes.slideBottom}>
                          <div className={classes.slideHeader}>
                            <h3 className={classes.projectTitle}>{project.title}</h3>
                            <span className={classes.categoryBadge}>{project.category}</span>
                          </div>

                          <h4 className={classes.projectSubtitle}>{project.subtitle}</h4>

                          <p className={classes.projectDescription}>{project.description}</p>

                          <a href={project.link} className={classes.learnMoreBtn}>
                            <span>Learn More</span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className={classes.navigation}>
                <button
                  className={`${classes.navBtn} ${classes.prevBtn}`}
                  onClick={prevSlide}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>

                <button
                  className={`${classes.navBtn} ${classes.nextBtn}`}
                  onClick={nextSlide}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>

              <div className={classes.indicators}>
                {mobileProjects.map((_, index) => (
                  <button
                    key={index}
                    className={`${classes.indicator} ${index === currentSlide ? classes.active : ''}`}
                    onClick={() => setCurrentSlide(index)}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className={classes.process}>
          <div className={classes.container}>
            <div className={classes.sectionHeader}>
              <h2 className={classes.sectionTitle}>
                Our Development <span className={classes.gradient}>Process</span>
              </h2>
              <p className={classes.sectionSubtitle}>
                A proven methodology that ensures successful mobile app delivery
              </p>
            </div>
            <div className={classes.processGrid}>
              {process.map((step, index) => (
                <div key={index} className={classes.processStep}>
                  <div className={classes.stepNumber}>{step.step}</div>
                  <h3 className={classes.stepTitle}>{step.title}</h3>
                  <p className={classes.stepDescription}>{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <FAQ faqs={faqs} title="Frequently Asked" highlight="Questions" />

        {/* Contact Form Section */}
        <section id="contact-form" className={contactClasses.contact}>
          <div className={contactClasses.container}>
            <div className={contactClasses.header}>
              <span className={contactClasses.badge}>Get Your Quote</span>
              <h2 className={contactClasses.title}>
                Let's Build Your <span className={contactClasses.gradient}>Mobile App</span>
              </h2>
            </div>

            <div className={contactClasses.content}>
              <form className={contactClasses.form} onSubmit={handleSubmit}>
                <div className={contactClasses.formRow}>
                  <div className={contactClasses.formGroup}>
                    <label htmlFor="name">
                      <MdPerson className={contactClasses.labelIcon} />
                      Full Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Enter your full name"
                      className={contactClasses.premiumInput}
                    />
                  </div>

                  <div className={contactClasses.formGroup}>
                    <label htmlFor="email">
                      <MdEmail className={contactClasses.labelIcon} />
                      Email Address
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="your.email@company.com"
                      className={contactClasses.premiumInput}
                    />
                  </div>
                </div>

                <div className={contactClasses.formGroup}>
                  <label htmlFor="phoneNumber">
                    <MdPhone className={contactClasses.labelIcon} />
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phoneNumber"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    required
                    placeholder="+1 (555) 123-4567"
                    className={contactClasses.premiumInput}
                  />
                </div>

                <div className={contactClasses.formGroup}>
                  <label htmlFor="message">
                    <MdMessage className={contactClasses.labelIcon} />
                    Mobile App Details
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Tell us about your mobile app vision - target platforms (iOS/Android), key features, timeline, and any specific requirements..."
                    className={contactClasses.premiumTextarea}
                  ></textarea>
                </div>

                <button type="submit" className={contactClasses.submitBtn} disabled={loading}>
                  <span className={contactClasses.btnText}>
                    {loading && <span className={contactClasses.spinner} />}
                    {loading ? 'Sending...' : 'Get My Quote'}
                  </span>
                  <div className={contactClasses.btnGlow}></div>
                </button>
              </form>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className={classes.cta}>
          <div className={classes.container}>
            <div className={classes.ctaContent}>
              <h2 className={classes.ctaTitle}>
                Ready to Build Your <span className={classes.gradient}>Mobile App</span>?
              </h2>
              <p className={classes.ctaSubtitle}>
                Let's discuss your project and create a mobile experience that delights your users
              </p>
              <a href="#contact-form" className={classes.ctaButton}>Start Your Project</a>
            </div>
          </div>
        </section>
      </div>
    </ServicePageLayout>
  );
};

export default MobileAppDevelopment;